import PropTypes from 'prop-types';
import ScheduleIcon from '@material-ui/icons/Schedule';
import MLink from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import { momentParse, dateAndTimeRange } from '../../utils/time';
import AddToCalendar from './add-to-calendar';
import InlineMarkdown from '../inline-markdown';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: theme.spacing(0, 0, 2, 0)
  },
  time: {
    display: 'flex',
    alignItems: 'center',
  },
  scheduleIcon: {
    marginRight: theme.spacing(0.5),
  },
  details: {
    marginLeft: theme.spacing(3.5),
    fontStyle: 'italic',
  },
  addToCalendar: {
    marginLeft: theme.spacing(3.5),
    marginTop: theme.spacing(0.5),
  },
}));

const EventDate = ({ event }) => {
  const classes = useStyles();

  if (!event.startAt) {
    return <div>TBD</div>;
  }

  const startAt = momentParse(event.startAt, event.timezone);
  const endAt = event.endAt ? momentParse(event.endAt, event.timezone) : null;
  const details = event.startAtDetails;

  return (
    <div className={classes.wrapper}>
      <div className={classes.time}>
        <ScheduleIcon className={classes.scheduleIcon} />
        <time
          dateTime={startAt.toString()}
          title={startAt.format('dddd, MMMM Do, YYYY h:mm a')}
        >
          {dateAndTimeRange(startAt, endAt)}
        </time>
      </div>
      {details && (
        <div className={classes.details}>
          <InlineMarkdown>{details}</InlineMarkdown>
        </div>
      )}
      <div>
        <AddToCalendar
          event={event}
          buttonComponent={MLink}
          role="button"
          href="#"
          className={classes.addToCalendar}
        />
      </div>
    </div>
  );
};

EventDate.propTypes = {
  event: PropTypes.object,
};

export default EventDate;
